import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Radio } from "@material-ui/core";
import { secondary } from "../../../../../../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: `${theme.spacing(2)}px ${theme.spacing(1)}px ${theme.spacing(
      1
    )}px ${theme.spacing(1)}px`,
  },
  radioContainer: { paddingRight: theme.spacing(3) },
}));

export const CustomRadio = withStyles({
  root: {
    color: secondary,
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&$checked": {
      color: secondary,

      "&:hover": { backgroundColor: "transparent" },
    },
  },
  checked: {},
})((props) => <Radio {...props} />);

export default useStyles;
